import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button } from 'ui-components/components/button';
import { Text, TextType } from 'ui-components/components/text';

import { requestBulkCancelOrder } from '../store/orders/orders.actions';
import { closedOrderDetailModal } from '../store/orders/order-details/orders.details.actions';
import Global from '../store/global-selectors';
import { useCreateDemoOrder } from './hooks/use-create-demo-order';
import { messages } from './messages';
import style from './style.module.less';

export const ResetDemoOrderButton = () => {
  const demoFulfillmentPlanId = useSelector(Global.selectSellerDemoFulfillmentPlanId).toString();
  const demoSalesOrders =
    useSelector((state) =>
      Global.selectEntitiesSalesOrdersByFulfillmentPlanIds(state, {
        fulfillmentPlanIds: [demoFulfillmentPlanId],
      }),
    ) || [];
  const demoFulfillmentPlans = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanById(state, {
      fulfillmentPlanId: demoFulfillmentPlanId,
    }),
  );

  const totalOrdersBeforeCancel = useSelector(Global.selectOrdersGridTotalRecords);
  const dispatch = useDispatch();

  const completeSelectedOrders = (selectedSalesOrders, selectedFulfillmentPlans) => {
    const newSalesOrders = selectedSalesOrders.reduce((acc, curr) => {
      const { fulfillmentPlanIds } = curr;
      const matchingFulfillmentPlans = selectedFulfillmentPlans.filter((plan) => fulfillmentPlanIds.includes(plan.fulfillmentPlanId));
      const newOrder = {
        salesOrder: curr,
        fulfillments: [],
        fulfillmentPlans: matchingFulfillmentPlans,
      };
      acc.push(newOrder);
      return acc;
    }, []);
    return newSalesOrders;
  };

  const findIdsToCancel = (orders, plansToCancel = []) => {
    orders.forEach((order) => {
      if (order.fulfillmentPlans) {
        findIdsToCancel(order.fulfillmentPlans, plansToCancel);
      } else {
        plansToCancel.push(order.fulfillmentPlanId);
      }
    });
    return plansToCancel;
  };
  const selectedOrders = completeSelectedOrders(demoSalesOrders, [demoFulfillmentPlans]);
  const idsToCancel = findIdsToCancel(selectedOrders);
  const createNewDemoOrder = useCreateDemoOrder();

  const onButtonClick = () => {
    dispatch(closedOrderDetailModal());
    dispatch(requestBulkCancelOrder(idsToCancel, totalOrdersBeforeCancel, false));
    createNewDemoOrder();
  };

  return (
    <Button className={style['reset-button']} onClick={onButtonClick} theme='unstyled'>
      <Text className={style['reset-text']} textType={TextType.Label} value={messages.resetButton} />
    </Button>
  );
};
